'use client';

import config from '@/config';
import { ArrowRight } from 'lucide-react';
import mixpanel from 'mixpanel-browser';
import ClassroomGameBoard from './ClassroomGameBoard';

const registerHref = `${config.appUrl}/register`;

export default function AltHero() {
  return (
    <section className="relative overflow-hidden bg-ink-900 text-paper-50">
      {/* Subtle dotted texture */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, #FDFAF3 1px, transparent 0)',
          backgroundSize: '22px 22px',
        }}
      />

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-8 pt-16 lg:pt-24 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: headline + CTAs */}
          <div className="lg:col-span-7">
            <h1 className="font-display font-black text-5xl md:text-6xl lg:text-[3.75rem] xl:text-[5rem] tracking-[-0.025em] leading-[0.98]">
              The Kahoot alternative where students{' '}
              <span className="italic font-medium text-brand-300">race,</span>{' '}
              not just score.
            </h1>

            <div className="mt-8 max-w-xl border-l-2 border-brand-300 pl-5">
              <p className="font-display text-lg lg:text-xl text-paper-50/85 leading-relaxed">
                QuizWhizzer turns your questions into a board game. Right
                answers move students along the track, powerups shake up the
                order, and the whole class watches the map instead of a podium.
              </p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                className="btn btn-primary btn-lg rounded-full px-8 text-white shrink-button btn-letterpress"
                href={registerHref}
                onClick={() =>
                  mixpanel.track('kahoot_alt_cta_clicked', {
                    location: 'hero',
                  })
                }
              >
                Try it free
                <ArrowRight className="w-5 h-5" />
              </a>
              <a
                className="btn btn-ghost btn-lg rounded-full px-8 text-paper-50 border-2 border-paper-50/80 hover:bg-paper-50 hover:text-ink-900 transition-colors"
                href="#comparison"
              >
                See the comparison
              </a>
            </div>

            <p className="font-display text-paper-50/55 text-sm mt-5">
              Free to use &middot; no credit card &middot;
              students join with a code, no accounts
            </p>
          </div>

          {/* Right: live game-board mock */}
          <div className="lg:col-span-5">
            <ClassroomGameBoard />
          </div>
        </div>
      </div>
    </section>
  );
}
